// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ad4fa9a103e700134803","678":"31caae4ac4df232a50fc","883":"15b9d1cfa2f0c2648962"}[chunkId] + ".js";
};